import { useState } from "react"

export const ReportStates = () => {
    const [eodSales, setEodSales] = useState({total_sales:0, actual_sales:0, eod:0, variance:0})
    const [salesProductList, setSalesProductList] = useState([])
    const [loader, setLoader] = useState({isLoader:false, isShowGenerate:true, isShowBtn:true,})
    const [messageModal, setMessageModal] = useState({isShowMessageModal:false, text: '', subText: ''})


    const [form, setForm] = useState({branch_id:0, product_id:0, from:'', to:'', user_id: 0})
    const [comProductIds, setComProductIds] = useState([])
    const [branchProductData, setBranchProductData] = useState([{id:0, sub_cat_name:'All', product_name:'', code:'000', active:1}])
    const [generateForm, setGenerateForm] = useState({infiniteLoad:false, limit:100, offset:0})
    const [salesProductData, setSalesProductData] = useState([])
    const [salesBranchList, setSalesBranchList] = useState([])
    const [salesBranchData, setSalesBranchData] = useState([])

    const [branchOrderData, setBranchOrderData] = useState([])
    const [branchOrderList, setBranchOrderList] = useState([])



    return {
        eodSales: {data: eodSales, set: setEodSales},
        salesProductList: {data: salesProductList, set: setSalesProductList},
        loader: {data: loader, set: setLoader},
        messageModal: {data: messageModal, set: setMessageModal},
        form: {data: form, set: setForm},
        comProductIds: {data: comProductIds, set: setComProductIds},
        branchProductData: {data: branchProductData, set: setBranchProductData},
        generateForm: {data: generateForm, set: setGenerateForm},
        salesProductData: {data: salesProductData, set: setSalesProductData},
        salesBranchList: {data: salesBranchList, set: setSalesBranchList},
        salesBranchData: {data: salesBranchData, set: setSalesBranchData},

        branchOrderData: {data: branchOrderData, set: setBranchOrderData},
        branchOrderList: {data: branchOrderList, set: setBranchOrderList},

    }
}